import { Component, ElementRef } from '@angular/core';
import { BroadcastAppService } from 'src/app/core';
import { SharedService } from '@shared/services/shared.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-shared-service',
    template: '',
    standalone: false
})
export class SharedServiceComponent {

  constructor(
    element: ElementRef,
    sharedService: SharedService,
    broadcastAppService: BroadcastAppService
    ) {
      element.nativeElement.sharedServices = sharedService;

      broadcastAppService.getAppSubject().subscribe(i => {
        element.nativeElement.dispatchEvent(new CustomEvent(i.type, {
          bubbles: false,
          detail: i.payload,
        }));
      });
    }
}
